export const environment = {
    name: 'development',
    apiUrl:'https://tfact.pspldemo.in/api/v1/',
    // apiUrl:'https://tfuat.pspldemo.in/api/v1/',
};
